"use client";
import { useMemo } from 'react';
import DOMPurify from 'dompurify'
import style from './style.module.scss';

type PropType = {
    body: string;
    customClasses?: string;
}

const allowedCss = [
    'display',
    'flex',
    'grid',
    'gap',
    'place-items',
    'justify-content',
    'align-items',
    'overflow',
    'visibility',

    'position',
    'top',
    'left',
    'right',
    'bottom',
    'z-index',
    'float',
    'clear',

    'color',
    'background-color',

    'font',
    'font-family',
    'font-size',
    'font-weight',
    'font-style',
    'text-align',
    'text-decoration',
    'text-indent',
    'text-transform',
    'line-height',
    'letter-spacing',
    'white-space',
    'word-break',
    'word-spacing',
    'vertical-align',

    'margin',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-bottom',
    'padding',
    'padding-left',
    'padding-right',
    'padding-top',
    'padding-bottom',

    'border',
    'border-top',
    'border-right',
    'border-bottom',
    'border-left',
    'border-color',
    'border-style',
    'border-width',
    'border-collapse',
    'border-spacing',
    'border-radius',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-top-left-radius',
    'border-top-right-radius',

    'width',
    'height',
    'min-width',
    'max-width',
    'min-height',
    'max-height',

    'table-layout',
    'empty-cells',
    'caption-side',

    'list-style-type',
    'list-style-position',

    'box-shadow',
    'outline',
    'opacity'
]

const EmailRender = ({ body, customClasses }: PropType) => {
    const validateStyles = (output: any, styles: any) => {
        Object.keys(styles).forEach(function(index) {
            if (styles.hasOwnProperty(index)) {
                    let normalizedKey = styles[index].replace(/([A-Z])/g, '-$1').toLowerCase();
                    if (allowedCss.includes(normalizedKey)) {
                        let value = styles[normalizedKey];
                        output.push(`${normalizedKey}:${value};`);
                }
            }
        });
    }

    DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
        if (data.attrName === 'align') {
            data.forceKeepAttr = true;
        }
    });

    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
            node.setAttribute('rel', 'noopener noreferrer');
        }

        if (node.hasAttribute('style')) {
            let output: any = [];
            validateStyles(output, (node as HTMLElement).style);
            // re-add styles in case any are left
            if (output.length) {
                node.setAttribute('style', output.join(""));
            } else {
                node.removeAttribute('style');
            }
        }
    });

    const cleanBody = useMemo(() => {
        return DOMPurify.sanitize(body, {
            ALLOWED_TAGS: [
                'div', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
                'ul', 'ol', 'li',
                'table', 'tr', 'th', 'td', 'tbody', 'thead', 'tfoot',
                'a', 
                'b', 'i', 'u', 'em', 'strong', 
                'blockquote', 
                'br',
                'pre',
                'text'
            ],
            ALLOWED_ATTR: [
                'href', 'target', 'rel', 
                'alt', 'title', 
                'align', 'border', 'cellpadding', 'cellspacing', 'bgcolor',  
                'width',
                'style'],
            ALLOWED_URI_REGEXP: /^(https?:\/\/|mailto:|\/|#)/i
        })
    }, [body]);

    return (
        <article dangerouslySetInnerHTML={{ __html: cleanBody }} className={`${customClasses} ${style.cEmailRender}`} />
    )
}

export default EmailRender